import {BrowserModule, Title} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {ServiceModule} from './services/service.module';
import {AppComponent} from './app.component';
import {GraphQLModule} from './graphql.module';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AppRoutingModule} from './app-routing.module';
import {MainComponent} from './main.component';
import {ErrorPageComponent} from './error-page/error-page.component';
import {RollbarErrorHandler, rollbarFactory, RollbarService} from './error-handlers/rollbar';
import {MaintenanceComponent} from './maintenance/maintenance.component';
import {PopUpComponent} from "./services/doorTypeValidation/pop-up-component";

declare global {
  interface Window {
    Konva: any;
  }
}

if (typeof window !== 'undefined' && !window.Konva) {
  import('konva').then((KonvaModule) => {
    window.Konva = KonvaModule.default;
  }).catch((error) => {
    console.error('Error loading Konva:', error);
  });
}

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    ErrorPageComponent,
    MaintenanceComponent,
    PopUpComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ServiceModule.forRoot(),
    GraphQLModule.forRoot(),
    NgbModule], providers: [
    Title,
    {provide: ErrorHandler, useClass: RollbarErrorHandler},
    {provide: RollbarService, useFactory: rollbarFactory},
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
}
